var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlansWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 173.693,
    height: 145.764,
    viewBox: "0 0 173.693 145.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69838",
    "data-name": "Group 69838",
    transform: "translate(-4974.57 -3949.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69837",
    "data-name": "Group 69837",
    transform: "translate(4974.57 3949.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7585",
    "data-name": "Path 7585",
    d: "M1144.148,962.922c17.032-34.029-3.43-81.125-35.341-101.44-25.022-15.929-51.6-11.9-67.426-7.04a94.958,94.958,0,0,0-12.987,5.023c-22.692,10.844-55.729,38.737-51.4,73.452,4.808,38.582,52.221,57.13,78.654,61.4C1062.576,995.441,1123.407,1004.36,1144.148,962.922Z",
    transform: "translate(-976.606 -850.124)",
    fill: "rgba(38,30,85,0.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_alert-circle-exc",
    transform: "translate(5108.264 3949.463)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M20,0A20,20,0,1,0,40,20,20.059,20.059,0,0,0,20,0Zm0,30a2.362,2.362,0,0,1-2.5-2.5A2.362,2.362,0,0,1,20,25a2.362,2.362,0,0,1,2.5,2.5A2.362,2.362,0,0,1,20,30Zm2.5-7.5h-5V10h5Z",
    fill: "#ffca83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35519",
    "data-name": "Group 35519",
    transform: "translate(5024.543 3996.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M2,3V65.688H75.75V3Zm7.375,7.375h59V58.313h-59ZM61,17.75l-7.375,7.375-3.688-3.688L46.25,25.125,53.625,32.5,64.687,21.437ZM13.063,21.437v7.375h29.5V21.437ZM61,36.188l-7.375,7.375-3.688-3.687L46.25,43.562l7.375,7.375L64.687,39.875ZM13.063,39.875V47.25h29.5V39.875Z",
    transform: "translate(-2 -3)",
    fill: "#767493"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansWarning);
export default __webpack_public_path__ + "static/media/plans_warning.4555dc2265d2809c01381a8eb7fc9096.svg";
export { ForwardRef as ReactComponent };